module.exports = __webpack_public_path__ + "img/question17c2.b0e0f30b.png";